import { styled } from "baseui";

export const StyledSingleLineText = styled<"div", {}>("div", ({ $theme }) => ({
  //width: "200px",
  whiteSpace: "nowrap" /* Prevents text from wrapping */,
  overflow: "hidden" /* Hides the overflow text */,
  textOverflow: "ellipsis" /* Adds an ellipsis (...) to indicate overflow */,
  ...$theme.typography.ParagraphSmall,
  maxLines: 3,
  color: $theme.colors.contentTertiary,
}));

export const StyledVerticalContent = styled<"div", {}>("div", ({ $theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: $theme.sizing.scale200,
}));

export const StyledHorizontalContent = styled<"div", {}>("div", ({ $theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: $theme.sizing.scale200,
}));
